module.exports = __webpack_public_path__ + "img/events_3.ecaa00d4.jpg";